import type { AlimentoMacronutriente, Prato } from '../types/database'

export type SecaoDescricaoInput = {
  descritivo: string
  pratoIds: string[]
  itens: Array<{ alimento_id: string }>
}

/** Texto gravado em `cardapios.descricao` a partir da seção da ficha. */
export function descricaoCardapioDaSecao(
  secao: SecaoDescricaoInput,
  pratos: Prato[],
  alimentosById: Map<string, AlimentoMacronutriente>,
): string {
  const nomesPratos = secao.pratoIds
    .map((id) => pratos.find((p) => p.id === id)?.nome)
    .filter(Boolean) as string[]
  const nomesAlimentos = secao.itens
    .map((it) => alimentosById.get(it.alimento_id)?.nome)
    .filter(Boolean) as string[]
  const base = secao.descritivo.trim()
  if (base && nomesPratos.length) return `${base} (${nomesPratos.join(', ')})`
  if (base) return base
  if (nomesPratos.length) return nomesPratos.join(', ')
  return nomesAlimentos.join(', ')
}

export function secaoTemConteudo(secao: SecaoDescricaoInput): boolean {
  return (
    secao.itens.some((it) => it.alimento_id) ||
    secao.descritivo.trim().length > 0 ||
    secao.pratoIds.length > 0
  )
}
